import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { QuestionnaireView } from '../views/QuestionnaireView';
import { useQuestionnaireTR } from '../hooks/tr/useQuestionnaireTR';
import { LoadingSpinner } from '../components/LoadingSpinner';

export function QuestionnaireContainerTR() {
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuth();

  const {
    currentQuestionNumber,
    totalQuestions,
    question,
    isHarmonic,
    handleAnswer,
    goToNext,
    goToPrevious,
    currentAnswer,
    canGoBack,
    draftProgress,
    resumeDraft,
    discardDraft,
  } = useQuestionnaireTR();

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/tr/login');
    }
  }, [user, authLoading, navigate]);

  if (authLoading) {
    return <LoadingSpinner message="Degerlendirme yukleniyor..." />;
  }

  if (draftProgress !== null) {
    return (
      <div className="min-h-screen freud-bg flex items-center justify-center px-6">
        <div className="freud-card-elevated p-10 max-w-md w-full text-center">
          <div className="w-14 h-14 bg-sage-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <svg className="w-7 h-7 text-sage-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <h2 className="freud-heading-xl text-chocolate-900 mb-3">Degerlendirmeye Devam Et?</h2>
          <p className="freud-text-base text-chocolate-500 mb-8">
            Kaydedilmis bir degerlendirmeniz var — {totalQuestions} sorudan {draftProgress + 1}. soruya kadar tamamlandi. Kaldıgınız yerden devam etmek ister misiniz?
          </p>
          <div className="flex flex-col gap-3">
            <button
              onClick={resumeDraft}
              className="freud-btn-primary w-full"
            >
              Kaldığım yerden devam et
            </button>
            <button
              onClick={discardDraft}
              className="freud-btn-secondary w-full"
            >
              Bastan basla
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!question) {
    return <LoadingSpinner message="Degerlendirme yukleniyor..." />;
  }

  return (
    <QuestionnaireView
      currentQuestion={currentQuestionNumber}
      totalQuestions={totalQuestions}
      question={question}
      isHarmonic={isHarmonic}
      handleAnswer={handleAnswer}
      goToNext={goToNext}
      goToPrevious={goToPrevious}
      currentAnswer={currentAnswer}
      canGoBack={canGoBack}
      labels={{
        scaleOptions: [
          { value: 1, label: 'Kesinlikle Katılmıyorum' },
          { value: 2, label: 'Katılmıyorum' },
          { value: 3, label: 'Biraz Katılmıyorum' },
          { value: 4, label: 'Nötr' },
          { value: 5, label: 'Biraz Katılıyorum' },
          { value: 6, label: 'Katılıyorum' },
          { value: 7, label: 'Kesinlikle Katılıyorum' },
        ],
        progressQuestion: 'Soru',
        progressOf: '/',
        progressComplete: 'Tamamlandı',
        scaleMin: '1 = Kesinlikle Katılmıyorum',
        scaleMax: '7 = Kesinlikle Katılıyorum',
        previousQuestion: 'Önceki Soru',
        backToInstructions: 'Talimatlara Dön',
      }}
    />
  );
}
